import { BaseDto } from './base.dto';
import { CountryDto } from './country.dto';
import { VATRateValueDto } from './vat-rate-value.dto';

export class VATRateDto extends BaseDto {
  vatClass: string;
  vatCode: string;
  effectiveVatRate?: string;
  effectiveFrom: Date;
  vatRateValue: VATRateValueDto[];
  country: CountryDto;
  countryName?: string;
}
